/**
 * Structured logger with mode-aware context
 */

// Guard for non-DOM test environments (node) — logger is browser-first but
// imported by modules that also run under plain vitest node environment.
const isDev = typeof window !== 'undefined' && window.location?.hostname === 'localhost'

function createLogger(module = 'workspace') {
  const prefix = `[${module}]`
  return {
    info: (...args) => isDev && console.log(prefix, ...args),
    warn: (...args) => console.warn(prefix, ...args),
    error: (...args) => console.error(prefix, ...args),
    debug: (...args) => isDev && console.debug(prefix, ...args),
  }
}

export const logger = createLogger()
export { createLogger }
export default logger
